import WymhSiteHeader from "@/components/feature/wymh-site-header";
import WymhSiteFooter from "@/components/feature/wymh-site-footer";
import WymhReportButton from "@/components/feature/wymh-report-button";
import WymhHero from "@/pages/home/components/wymh-hero";
import WymhTicker from "@/pages/home/components/wymh-ticker";
import WymhLibrary from "@/pages/home/components/wymh-library";
import WymhPreview from "@/pages/home/components/wymh-preview";
import WymhReading from "@/pages/home/components/wymh-reading";
import WymhFaq from "@/pages/home/components/wymh-faq";
import { useWymhSiteConfig } from "@/hooks/wymh-site-config";
import { useWymhSeo } from "@/hooks/wymh-seo";

export default function Home() {
  const config = useWymhSiteConfig();

  useWymhSeo({
    title: "五一漫画 – 装进口袋的随身漫摊",
    keywords: "五一漫画",
    description:
      "五一漫画是一款漫画阅读神器，海量热门国漫、日漫、韩漫免费看。高清全彩画质，章节实时更新，支持离线缓存，随时随地装进口袋畅快追更，让精彩漫画陪伴你的每个碎片时光。",
    canonical: "https://www.wuyicomic.com/",
  });

  return (
    <div className="w-full min-h-screen bg-background-50">
      <WymhSiteHeader config={config} />
      <main>
        <WymhHero />
        <WymhTicker />
        <WymhLibrary />
        <WymhPreview />
        <WymhReading />
        <WymhFaq />
      </main>
      <WymhSiteFooter config={config} />
      <WymhReportButton />
    </div>
  );
}